import { render, staticRenderFns } from "./PartnerShip.vue?vue&type=template&id=a651df68&scoped=true"
import script from "./PartnerShip.vue?vue&type=script&lang=js"
export * from "./PartnerShip.vue?vue&type=script&lang=js"
import style0 from "./PartnerShip.vue?vue&type=style&index=0&id=a651df68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a651df68",
  null
  
)

export default component.exports